<template>
  <f7-page>
    <navbar :text="$t('ExtremeWeatherCondicions_title')" />
    <DxExtremeWeatherCondicionsDatabase />
  </f7-page>
</template>

<script>

import DxExtremeWeatherCondicionsDatabase from '../../components/scouting/DxExtremeWeatherCondicionsDatabase.vue';
import navbar from '../../components/NavBar.vue';

export default {
  components: {
    DxExtremeWeatherCondicionsDatabase,
    navbar,
  },
};
</script>

<style>

</style>
